import { render, staticRenderFns } from "./bundle-product.vue?vue&type=template&id=3099fed6&"
import script from "./bundle-product.vue?vue&type=script&lang=js&"
export * from "./bundle-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports